import axios from "axios";
import { getBackendUrl } from "./backend.url";

export const getFaq = () => {
  return axios.get(`${getBackendUrl()}/faq`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const addFaq = (faq) => {
  return axios.put(`${getBackendUrl()}/faq`, faq, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const addFaqEntry = (faqId, faqEntry) => {
  return axios.put(`${getBackendUrl()}/faq/${faqId}`, faqEntry, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const removeFaq = (id) => {
  return axios.delete(`${getBackendUrl()}/faq/${id}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const removeFaqEntry = (id, entryId) => {
  return axios.delete(`${getBackendUrl()}/faq/${id}/entry/${entryId}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};
